import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useFavorites } from "@/lib/favorites";

export const FavoriteButton = ({ track, testId = "favorite-btn", className = "" }) => {
  const { has, toggle } = useFavorites();
  const navigate = useNavigate();
  if (!track?.title) return null;
  const active = has(track);
  const onClick = () => {
    const added = toggle(track);
    if (added) {
      toast.success("Ajouté à tes favoris", {
        description: `${track.artist ? `${track.artist} - ` : ""}${track.title}`,
        action: { label: "Voir", onClick: () => navigate("/radio#favoris") },
      });
    } else {
      toast("Retiré de tes favoris");
    }
  };
  return (
    <button type="button" onClick={onClick} aria-pressed={active}
      aria-label={active ? "Retirer des favoris" : "Ajouter aux favoris"} title={active ? "Retirer des favoris" : "Ajouter aux favoris"}
      data-testid={testId} data-active={active ? "true" : "false"}
      className={`shrink-0 grid place-items-center border transition-colors duration-200 ${active ? "bg-primary border-primary text-white" : "border-white/20 text-zinc-300 hover:border-primary hover:text-primary"} ${className}`}>
      <Heart className={`w-4 h-4 ${active ? "fill-current" : ""}`} />
    </button>
  );
};
